import { FC } from 'react';
import { GetServerSideProps } from 'next';
import dynamic from 'next/dynamic';
import { shallowEqual, useSelector } from 'react-redux';
import { SmartGridToken } from '@components/smart-grid-token';
import { FEED_TYPE, ONE_MINUTE_MILLIS } from '@constants';
import { RootState } from '@state/store';
import { customFloor } from '@utils/math';

const Filters = dynamic(() => import('@components/homepage-filter'), { ssr: false });

const Homepage: FC = () => {
  const { user } = useSelector((state: RootState) => state.auth);
  const startTime = customFloor(Date.now(), ONE_MINUTE_MILLIS);
  const { feed } = useSelector(
    (state: RootState) => state.settings,
    (left, right) => shallowEqual(left.feed, right.feed)
  );
  const { appearance } = useSelector(
    (state: RootState) => state.settings,
    (left, right) => shallowEqual(left.appearance, right.appearance)
  );

  return (
    <main>
      {user?.id && <Filters feed={feed.type as FEED_TYPE} />}

      {user?.id && feed.type === FEED_TYPE.PERSONAL ? (
        <SmartGridToken
          api={`/api/user/${user?.id}/feed`}
          limit={30}
          masonry={appearance.masonry}
          info={appearance.info}
          market={appearance.market}
          labels={appearance.labels}
          nodata="No data in your personal feed. Try following some users, boards or liking some tokens"
          maxtime={startTime}
        />
      ) : (
        <SmartGridToken
          api="/api/public/feed"
          limit={30}
          masonry={appearance.masonry}
          info={appearance.info}
          market={appearance.market}
          labels={appearance.labels}
          maxtime={startTime}
        />
      )}
    </main>
  );
};

export default Homepage;

export const getServerSideProps: GetServerSideProps = async ({ res, locale }) => {
  res.setHeader('Cache-Control', 's-maxage=60, stale-while-revalidate');
  return {
    props: {
      messages: await import(`../locales/${locale}.json`).then((e) => e.default),
    },
  };
};
